import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatPrice, convertFromEur } from '@/lib/utils';

interface ReservedBalanceNoticeProps {
  /**
   * Part du solde gelée par un retrait en cours, en unités MAJEURES
   * (`WalletBalance.reserved` / `SellerBalance.reserved`, déjà converti
   * côté serveur — `seller-balance-units.helper.ts`). Doc 55, Task B1 :
   * c'est l'écart entre `volume30dMinor` (pay-saas) et `available` (web-pro).
   * Le parent (`PayoutRequestForm`) ne rend ce composant que si
   * `reserved > 0` — pas de re-vérification ici.
   */
  reserved: number;
  currency: string;
}

/** Ligne « Réservé » sous le solde disponible — explique la somme gelée au lieu de la laisser invisible. */
export function ReservedBalanceNotice({ reserved, currency }: ReservedBalanceNoticeProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between pt-3 border-t border-border/60">
      <div className="flex items-center gap-2">
        <Lock className="size-4 text-muted-foreground" />
        <div>
          <p className="text-sm text-muted-foreground">{t('payouts.request.reservedBalance')}</p>
          <p className="text-xs text-muted-foreground">{t('payouts.request.reservedExplanation')}</p>
        </div>
      </div>
      <span className="font-medium">{formatPrice(convertFromEur(reserved, currency), currency)}</span>
    </div>
  );
}
